<script setup>
import { computed } from 'vue';
import { scorePercent, scoreClass } from '../utils/scoring.js';

const props = defineProps({
	value: { type: [Number, String], default: null },
	fieldKey: { type: String, default: '' }
});

const percent = computed(() => scorePercent(props.value, props.fieldKey));
const cls = computed(() => scoreClass(percent.value));
</script>

<template>
	<span v-if="percent != null" class="tnt-score-wrap" :class="cls">
		<span class="tnt-score-pill">{{ percent }}%</span>
	</span>
</template>
